import axios from 'axios';
import { getCookie } from '../util_functions';

// Every request needs a ceiling: axios defaults to no timeout, so a stalled
// socket leaves the promise pending forever and callers that optimistically
// updated their UI never learn the write failed.
export const DEFAULT_TIMEOUT_MS = 15000;
// File uploads legitimately run longer than a normal API call, so they get a
// wider ceiling instead of being excluded from the timeout.
export const UPLOAD_TIMEOUT_MS = 120000;

const resolveTimeout = (type, timeout) => {
  if (typeof timeout === 'number') return timeout;
  return type === 'formdata' ? UPLOAD_TIMEOUT_MS : DEFAULT_TIMEOUT_MS;
};

export const post_api = (url, payload, token = false, type = 'none', timeout = null) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${getCookie('cms_token_3')}`;
  }
  if (type === 'formdata') {
    headers['content-type'] = 'multipart/form-data';
  }
  return new Promise((resolve, reject) =>
    axios({
      method: 'post',
      url,
      headers,
      data: payload,
      timeout: resolveTimeout(type, timeout)
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      })
  );
};

export const put_api = (url, payload, token = false, type = 'none', timeout = null) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${getCookie('cms_token_3')}`;
  }
  if (type === 'formdata') {
    headers['content-type'] = 'multipart/form-data';
  }
  return new Promise((resolve, reject) =>
    axios({
      method: 'put',
      url,
      headers,
      data: payload,
      timeout: resolveTimeout(type, timeout)
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      })
  );
};

export const api_with_method = (
  api_method,
  url,
  payload,
  token = false,
  type = 'none',
  timeout = null
) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${getCookie('cms_token_3')}`;
  }
  if (type === 'formdata') {
    headers['content-type'] = 'multipart/form-data';
  }
  return new Promise((resolve, reject) =>
    axios({
      method: api_method,
      url,
      headers,
      data: payload,
      timeout: resolveTimeout(type, timeout)
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      })
  );
};

export const get_api = (url, token = false, timeout = null) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${getCookie('cms_token_3')}`;
  }
  return axios({
    method: 'get',
    url,
    headers,
    timeout: resolveTimeout('none', timeout)
  })
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
};

export const delete_api = (url, token = false, timeout = null) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${getCookie('cms_token_3')}`;
  }
  return axios({
    method: 'delete',
    url,
    headers,
    timeout: resolveTimeout('none', timeout)
  })
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
};
